//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import sampleModal from './sampleModal'
import { mapGetters } from 'vuex'
export default {
  name: 'Sample',
  extends: vComponent,
  components: { sampleModal },
  computed: {
    ...mapGetters([
      'language'
    ])
  },
  methods: {
    openModal () {
      this.showModal('sampleModal')
    },
    async fetchData () {
      const result = await this.fetch('sample')
      console.log(result)
    },
    async doRequest () {
      const result = await this.fetchURL('localhost:3138/sample/text', 'GET', { x: 1, y: 2 })
      console.log(result)
    },
    async doDispatch () {
      this.dispatch('setLanguage', 'us')
    }
  }
}
